import { render } from "./Glossary.vue?vue&type=template&id=d2a42b9a"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"

import "./Glossary.vue?vue&type=style&index=0&id=d2a42b9a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__